export const reducer_me = (state, { userId, userName,  userRoles, companyLogoUrl }) => {
  return {
    ...state,
    userRoles,
    user: {
      ...state.user,
      userId,
      userName,
      userRoles,
      companyLogoUrl
    }
  }
}
